import type { IResponse } from '@/features/api/extranet'
import type { ContactAktoDTO } from '@/features/api/extranet/dto/shared'
import { useAppStateStore } from '@/features/application'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export async function loadContacts(init?: RequestInit): Promise<ContactAktoDTO[] | null> {
  const appState = useAppStateStore()
  if (!init)
    init = {
      sablier: false,
      dialogMode: 'silent',
      appCache: true,
      appCacheAddKey: [appState.contextCourant, appState.utilisateur?.emailAffichage],
      appCacheDurationEnSecondes: 300,
    }

  const fetch = useFetch('extranet')

  const url = '/contacts'

  const response = await fetch(url, init)
  if (response.status === 204) return null

  ensureSuccessStatusCode(response)

  const result = (await response.json()) as IResponse<ContactAktoDTO[]>

  return result.data
}
